/* eslint-disable no-unused-expressions */
import React, { useState } from "react";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import { updateData } from "../../../hooks/update";
import { apiPath, RoutePath } from "../../../utility/Constant";
import { AnimatePresence, motion } from "framer-motion";
import { SortableHandle } from "react-sortable-hoc";
import { MdDragIndicator } from "react-icons/md";

const GalleryContent = ({ galleriesContentData, handleSingleDelete, dragHandle }) => {
  const { galleriesApi } = apiPath;
  const [visibility, setVisibility] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const { aboutUsGalleries } = RoutePath;

  const { title, short_description, country_name, gallery_img, _id } =
    galleriesContentData ?? {};

  const imagesData = gallery_img?.map((item, index) => ({
    label: `Banner Image ${index + 1}`,
    type: "file",
    name: "",
    defaultValue: typeof item === "string" ? item : item?.url,
    _id: item?._id || null,
  })) || [];

  const data = [
    {
      elementType: "input",
      label: "country name",
      type: "Text",
      name: "country_name",
      defaultValue: country_name,
      required: false,
    },
    {
      elementType: "input",
      label: "title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "textField",
      label: "short description",
      type: "Text",
      name: "short_description",
      defaultValue: short_description,
      required: false,
    },
  ];

  const nestedData = [
    {
      elementType: "gFile",
      label: "Gallery Image",
      name: "gallery_img",
      multipleData: imagesData,
      multiple: true,
      required: false,
      isGalleryFile: true,
    },
  ];

  const useData = data.concat(nestedData);

  async function helperFunction() {
    const res = await handleSingleDelete(_id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  }

  const update = (data) => {
    let { gallery_img, ...rest } = data;

    if (!Array.isArray(gallery_img)) {
      gallery_img = gallery_img ? [gallery_img] : [];
    }

    const newGallery = gallery_img.map((img, idx) =>
      typeof img === "string"
        ? { url: img }
        : {
          _id: img._id ?? undefined,
          url: img.url,
          imgId: img.imgId ?? idx + 1,
        }
    );

    rest.gallery_img = newGallery;
    rest.gallery_title = "GALLERY";

    updateData(galleriesApi, rest, _id);

    setTimeout(() => {
      window.location.href = "/" + aboutUsGalleries;
    }, 800);
  };




  const DragHandle = SortableHandle(() => (
    <div className="pointer-events-auto cursor-move">
      <MdDragIndicator className="w-5 h-5 text-gray-400" />
    </div>
  ));

  return visibility ? (
    <div className="border rounded-lg mb-4 shadow-sm overflow-hidden">
      {/* Accordion Header */}
      <button
        className="w-full text-left px-5 py-3 bg-gray-100 hover:bg-gray-200 transition-all flex justify-between items-center"
        onClick={() => setIsOpen((prev) => !prev)}
        type="button"
      >
        <div className="flex items-center">
          <div className="mr-2 pointer-events-none">
            <DragHandle />
          </div>
          <h2 className="text-lg font-semibold pointer-events-auto">
            {country_name}
          </h2>
        </div>
        <span className="text-xl">{isOpen ? "−" : "+"}</span>
      </button>



      {/* Animated Accordion Body */}
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className="p-5">
              <GlobalForm
                data={useData}
                nestedGalleryData={nestedData}
                update={update}
                deleteBtn={true}
                helperFunction={helperFunction}
                isGalleryFile={true}
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  ) : null;
};

export default GalleryContent;
